import React from "react";

/**
 * DS ButtonMini — figma 290:465 "button-mini".
 *
 * white bg + border Default, radius 6, gap 6
 * padding: pl=12 pr=16 py=8
 * 아이콘 16×16 left, 텍스트 Pretendard SemiBold 14/22 Text/Secondary
 *
 * "옵션 추가", "사이드메뉴 추가", "추가하기" 등 section header 의 우측 액션 버튼에 사용.
 *
 * @param {object} props
 * @param {React.ReactNode} [props.icon]
 * @param {React.ReactNode} props.children
 * @param {() => void} [props.onClick]
 * @param {boolean} [props.disabled]
 */
const DSButtonMini = ({ icon, children, onClick, disabled, className = "" }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`ds-button-mini ${className}`}
    >
      {icon && <span className="ds-button-mini__icon">{icon}</span>}
      <span>{children}</span>
    </button>
  );
};

export default React.memo(DSButtonMini);
